import './Modal.scss';

const Modal = ({ children, toggleShow, isContact }) => {
  return (
    <>
      <div className="backdrop" onClick={toggleShow}></div>
      <div className={`${isContact ? 'contact-modal' : 'modal'}`}>
        {children}
      </div>
    </>
  );
};

export default Modal;
